import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '@gray/domain/http/api.service';

/** The coach's side of the chat with one of their students. */
@Injectable({providedIn: 'root'})
export class CoachChatService {

  private apiPrefix = '/coach/chat';

  constructor(
    private api: ApiService,
  ) {
  }

  /** Every current student with the head of the conversation; `search`, `filter[unread]=1`. */
  getConversations(queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/conversations`, queryString);
  }

  /** `{total, conversations}` across all current students, for the menu badge. */
  getUnreadCount(): Observable<any> {
    return this.api.get(`${this.apiPrefix}/unread-count`);
  }

  getConversation(studentId: number): Observable<any> {
    return this.api.get(`${this.apiPrefix}/students/${studentId}`);
  }

  /** Newest first; the thread reverses them. */
  getMessages(studentId: number, queryString = ''): Observable<any> {
    return this.api.get(`${this.apiPrefix}/students/${studentId}/messages`, queryString);
  }

  sendMessage(studentId: number, body: string): Observable<any> {
    return this.api.post(`${this.apiPrefix}/students/${studentId}/messages`, {body});
  }

  markRead(studentId: number): Observable<any> {
    return this.api.post(`${this.apiPrefix}/students/${studentId}/read`, {});
  }
}
